module.exports = __webpack_public_path__ + "assets/img/qr-code-black.0fe51918.png";